import { render, staticRenderFns } from "./theatreManualHint.vue?vue&type=template&id=604399e2&scoped=true&"
import script from "./theatreManualHint.vue?vue&type=script&lang=js&"
export * from "./theatreManualHint.vue?vue&type=script&lang=js&"
import style0 from "./theatreManualHint.vue?vue&type=style&index=0&id=604399e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604399e2",
  null
  
)

export default component.exports